import React from "react";

function CartLayout({ children }) {
  return <div className="grid w-full my-4 font-mono h-screen">{children}</div>;
}

export default CartLayout;
